import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import Fab from '@material-ui/core/Fab';
import Badge from '@material-ui/core/Badge';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PersonIcon from '@material-ui/icons/Person';
import ja from "date-fns/locale/ja";
import './Css/Grid.css';
import DateFnsUtils from '@date-io/date-fns';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import KyDetails from '../KyDetail/Index';
import BulkIndex from '../RentMoney/BulkIndex';
import * as RentMoney from '../RentMoney/Saga/RentMoney';
import * as RentMoneyBulkInsert from './Saga/RentMoneyBulkInsert';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import IconButton from '@material-ui/core/IconButton';
const { MuiPickersUtilsProvider, KeyboardDatePicker } = require('@material-ui/pickers');
var moment = require('moment-timezone');


var SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
};


function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}
class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);

    this._onSortChange = this._onSortChange.bind(this);
  }

  render() {
    var { onSortChange, sortDir, children, ...props } = this.props;
    return (
      <Cell {...props} onClick={this._onSortChange}>

        {children} {sortDir ? (sortDir === SortTypes.DESC ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />) : ''}

      </Cell>
    );
  }

  _onSortChange(e) {

    e.preventDefault();

    if (this.props.onSortChange) {
      this.props.onSortChange(
        this.props.columnKey,
        this.props.sortDir ?
          reverseSortDirection(this.props.sortDir) :
          SortTypes.DESC
      );
    }
  }
}
const columns = [
  {
    key: 'bk_no', name: '建物No', width: 50,

  },
  { key: 'bk_name', name: '建物名', width: 300 },


  // { key: 'kaiyaku_date', name: '解約日', width: 90, frozen: true },
  // // { key: 'owner_kaiyaku_date', name: '解約報告日', width: 80, resizable: true },
  // { key: 'kei_name', name: '入居者名', width: 120 },
  // { key: 'shoyuusha_name', name: '所有者', width: 120 },
  // { key: 'shoyuusha_tantou_name', name: '担当', width: 50 },

  // { key: 'kouji_tantou_name', name: '工事担当', width: 50 },
  // { key: 'kuushitsu_joukyou_name', name: '募集状況', width: 60 },
  // { key: 'madori_name', name: '間取', width: 50 },
  // { key: 'senyuu_menseki', name: '占有面積', width: 50 },
  // { key: 'kouzou_name', name: '構造', width: 50 },
  // { key: 'choiki', name: '町域', width: 50 },
  // { key: 'shunkou', name: '竣工', width: 90 },



  // { key: 'kouji_gyousha', name: '業者名', width: 80 },
  // { key: 'kaiyaku_owner_renraku', name: '解約報告日', width: 145 },
  // { key: 'kagi_uketori_date', name: '鍵受取日', width: 90 },
  // { key: 'estimate_request', name: '見積依頼日', width: 90 },
  // // { key: 'tatemonoAddress1', name: '建物住所', width: 100,resizable: true },
  // { key: 'estimate_receives', name: '見積受取日', width: 120 },
  // // { key: 'estimate_confirm', name: '見積確定日', width: 90 },
  // // { key: 'kanri_order_at', name: '管理部発注日', width: 90 },
  // // { key: 'end_at', name: '終了日', width: 90, resizable: true, formatter: DateFormatter },
  // { key: 'order_at', name: '工事発注日', width: 90 },
  // // { key: 'payment_at', name: '入金日',width: 80, resizable: true, formatter: DateFormatter},
  // { key: 'hoshuu_date', name: '完工予定日', width: 90 },
  // { key: 'completion_at', name: '完工日', width: 90, resizable: true },

  // { key: 'after_check', name: '設備チェック', width: 90, resizable: true },

  // { key: 'completion_owner_report_at', name: '完工報告日', width: 145, resizable: true },

  // { key: 'next_keiyaku_date', name: '次回入居日', width: 90, resizable: true },

]




const TatemonoName = ({ column, props, rowIndex, onBkopen }) =>
  <Cell style={{ whiteSpace: "nowrap" }}>  <IconButton onClick={() => onBkopen(props.rent_money_bulk_insert_list[rowIndex].bk_no)}> < HomeWorkIcon color="primary" /></IconButton >{props.rent_money_bulk_insert_list[rowIndex][column.key]}</Cell>;
const RoomName = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.rent_money_bulk_insert_list[rowIndex][column.key]}</Cell>;


const KaiyakuDate = ({ column, props, rowIndex }) =>
  // <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%", background: moment(props.seisan_follow_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') > moment().tz("Asia/Tokyo").format('YYYY/MM/DD') ? "#87cefa" : "#98fb98" }} >
  <Cell style={{ whiteSpace: "nowrap", width: "100%", height: "100%" }} >

    {props.rent_money_bulk_insert_list[rowIndex][column.key] ? moment(props.rent_money_bulk_insert_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') : ""}

    <br />{props.rent_money_bulk_insert_list[rowIndex].taikyo_yotei_date && moment(props.rent_money_bulk_insert_list[rowIndex].taikyo_yotei_date).tz("Asia/Tokyo").format('YYYY/MM/DD') !== moment(props.rent_money_bulk_insert_list[rowIndex].kaiyaku_date).tz("Asia/Tokyo").format('YYYY/MM/DD') ? <b>退予 {moment(props.rent_money_bulk_insert_list[rowIndex].taikyo_yotei_date).tz("Asia/Tokyo").format('M/DD')} </b> : ""}

    {/* <Badge badgeContent={"次2日"} color="secondary">　</Badge> */}

  </Cell >;

const KaiyakuOwnerRenraku = ({ column, props, rowIndex, update_kaiyaku_owner_renraku, }) => <Cell style={{ width: "100%", height: "100%" }} >
  {props.rent_money_bulk_insert_list[rowIndex].changing ? <div style={{ zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "300px", height: "300px", marginLeft: -15, marginTop: -30 }}></div> :

    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja} >

      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy/MM/dd"
        margin="normal"
        id="date-picker-estimate2"
        autoOk={true}
        // label="始期日"
        onChange={(e, value) => update_kaiyaku_owner_renraku(value, props.rent_money_bulk_insert_list[rowIndex].keiyaku_no)}
        name="start_date"
        value={props.rent_money_bulk_insert_list[rowIndex].kaiyaku_owner_renraku ? props.rent_money_bulk_insert_list[rowIndex].kaiyaku_owner_renraku : null}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}

      // invalidDateMessage={"日付の形式が違います"}
      />
    </MuiPickersUtilsProvider>
  }
</Cell >;


const CompletionOwnerReortAt = ({ column, props, rowIndex, update_completion_owner_report_at, }) => <Cell style={{ width: "100%", height: "100%" }} >
  {props.rent_money_bulk_insert_list[rowIndex].changing ? <div style={{ zIndex: 3000, background: "rgba(45,45,45, 0.5)", width: "300px", height: "300px", marginLeft: -15, marginTop: -30 }}></div> :

    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ja} >

      <KeyboardDatePicker
        disableToolbar
        variant="inline"
        format="yyyy/MM/dd"
        margin="normal"
        id="date-picker-estimate2"
        autoOk={true}
        // label="始期日"
        onChange={(e, value) => update_completion_owner_report_at(value, props.rent_money_bulk_insert_list[rowIndex].keiyaku_no)}
        name="start_date"
        value={props.rent_money_bulk_insert_list[rowIndex].completion_owner_report_at ? props.rent_money_bulk_insert_list[rowIndex].completion_owner_report_at : null}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}

      // invalidDateMessage={"日付の形式が違います"}
      />
    </MuiPickersUtilsProvider>
  }
</Cell >;

const DateCheck = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap", background: props.rent_money_bulk_insert_list[rowIndex][column.key] ? "#f5f5f5" : "pink", width: "100%", height: "100%" }} >{props.rent_money_bulk_insert_list[rowIndex][column.key] ? moment(props.rent_money_bulk_insert_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD') : ""}</Cell>;


const EstimateCheck = ({ column, props, rowIndex, open_estimate }) =>
  <Cell style={{ whiteSpace: "nowrap", background: props.rent_money_bulk_insert_list[rowIndex][column.key] ? "#f5f5f5" : "pink", width: "100%", height: "100%" }} >
    {props.rent_money_bulk_insert_list[rowIndex][column.key] ? <div><IconButton onClick={() => open_estimate(props.rent_money_bulk_insert_list[rowIndex].keiyaku_no)}><LibraryBooksIcon color="primary" /></IconButton> {moment(props.rent_money_bulk_insert_list[rowIndex][column.key]).tz("Asia/Tokyo").format('YYYY/MM/DD')}</div> : ""}</Cell>;



const Owner = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >  <IconButton onClick={() => props.toggle_owner(props.rent_money_bulk_insert_list[rowIndex].shoyuusha_id)} >< AssignmentIndIcon color="primary" />  </IconButton> {props.rent_money_bulk_insert_list[rowIndex][column.key]}</Cell>;

const Keiyakusha = ({ column, props, rowIndex, onKyopen }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.rent_money_bulk_insert_list[rowIndex].ky_no ? <IconButton onClick={() => onKyopen(props.rent_money_bulk_insert_list[rowIndex].bk_no, props.rent_money_bulk_insert_list[rowIndex].hy_no, props.rent_money_bulk_insert_list[rowIndex].ky_no)}>< PersonIcon color="primary" /></IconButton> : ""} {props.rent_money_bulk_insert_list[rowIndex][column.key]}</Cell>;

const Shunkou = ({ column, props, rowIndex, onKyopen }) => <Cell style={{ whiteSpace: "nowrap" }} >{props.rent_money_bulk_insert_list[rowIndex].shunkou_year && props.rent_money_bulk_insert_list[rowIndex].shunkou_month ? props.rent_money_bulk_insert_list[rowIndex].shunkou_year + '年' + props.rent_money_bulk_insert_list[rowIndex].shunkou_month + "月築" : ""}</Cell>;

const Base = ({ column, props, rowIndex }) =>
  <Cell style={{ whiteSpace: "nowrap" }} >{props.rent_money_bulk_insert_list[rowIndex][column.key]}</Cell>;

class CustomerList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: columns,
      reflash: false,
      rent_money_toggle: false,
      colSortDirs: {},
      // dataList: new FakeObjectDataListStore(1000000),
      // columnWidths: {
      //   firstName: 240,
      //   lastName: 150,
      //   sentence: 140,
      //   companyName: 60,
      // },
    };




    this._onColumnResizeEndCallback = this._onColumnResizeEndCallback.bind(this);

    this._onSortChange = this._onSortChange.bind(this);

    this.onBkopen = this.onBkopen.bind(this);
    this.rent_money_toggle = this.rent_money_toggle.bind(this);


  }
  _onColumnResizeEndCallback(newColumnWidth, columnKey) {

    let columnsset = this.state.columns.map(function (value) {
      if (value.key === columnKey) {
        value.width = newColumnWidth
      }
      return value
    })

    this.setState({ columns: columnsset })

  }


  rent_money_toggle() {
    this.setState({ rent_money_toggle: !this.state.rent_money_toggle })
  }


  _onSortChange(columnKey, sortDir) {

    // alert(columnKey)
    // alert(_defaultSortIndexes.indexOf(columnKey))
    let rent_money_bulk_insert_list = this.props.rent_money_bulk_insert_list;
    rent_money_bulk_insert_list.sort((indexA, indexB) => {
      // alert(indexA)
      // alert(indexA[columnKey])
      var valueA = indexA[columnKey];
      var valueB = indexB[columnKey];
      var sortVal = 0;
      if (valueA > valueB) {
        sortVal = 1;
      }
      if (valueA < valueB) {
        sortVal = -1;
      }

      if (!valueA && !valueB) {
        sortVal = 0
      }
      if (!valueA) {
        sortVal = -1
      }
      if (!valueB) {
        sortVal = 1
      }


      if (sortVal !== 0 && sortDir === SortTypes.DESC) {
        sortVal = sortVal * -1;
      }

      return sortVal;
    });
    this.props.change_rent_money_bulk_insert_list(rent_money_bulk_insert_list)
    this.setState({
      // sortedDataList: new DataListWrapper(sortIndexes, this._dataList),
      colSortDirs: {
        [columnKey]: sortDir,
      },
    });
  }
  onBkopen(bk_no) {
    this.props.change_bk_no(bk_no)
    this.setState({ rent_money_toggle: !this.state.rent_money_toggle })

  }
  render() {

    return (
      <div id="bulk">
        <Table
          rowHeight={35}
          rowsCount={this.props.rent_money_bulk_insert_list.length}
          onColumnResizeEndCallback={this._onColumnResizeEndCallback}
          width={window.innerWidth - 110}
          height={window.innerHeight - 260}
          headerHeight={40}>
          {columns.map(function (value, i) {
            return <Column
              columnKey={value.key}
              header={<SortHeaderCell
                onSortChange={this._onSortChange}
                sortDir={this.state.colSortDirs[value.key]}
                style={{ whiteSpace: "nowrap" }}>{value.name}</SortHeaderCell>}

              // cell={({ rowIndex, ...props }) => (<Cell style={{ whiteSpace: "nowrap" }} >{this.props.seisan_follow_list[rowIndex][value.key]}</Cell>)}
              cell={({ rowIndex, ...props }) => (

                value.key === "bk_name" ? <TatemonoName column={value} props={this.props} rowIndex={rowIndex} onBkopen={this.onBkopen}></TatemonoName>
                  : value.key === "room_name" ? <RoomName column={value} props={this.props} rowIndex={rowIndex}></RoomName>
                    : value.key === "kaiyaku_date" ? <KaiyakuDate column={value} props={this.props} rowIndex={rowIndex}></KaiyakuDate>
                      : value.key === "order_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                        : value.key === "hoshuu_date" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                          : value.key === "kagi_uketori_date" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>

                            : value.key === "completion_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                              : value.key === "estimate_request" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                : value.key === "after_check" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                  : value.key === "estimate_receives" ? <EstimateCheck column={value} props={this.props} rowIndex={rowIndex} open_estimate={this.open_estimate}></EstimateCheck>
                                    : value.key === "shoyuusha_name" ? <Owner column={value} props={this.props} rowIndex={rowIndex}></Owner>
                                      : value.key === "kei_name" ? <Keiyakusha column={value} props={this.props} rowIndex={rowIndex} onKyopen={this.onKyopen} ></Keiyakusha>
                                        : value.key === "shunkou" ? <Shunkou column={value} props={this.props} rowIndex={rowIndex} ></Shunkou>

                                          : value.key === "kanri_order_at" ? <DateCheck column={value} props={this.props} rowIndex={rowIndex}></DateCheck>
                                            : value.key === "kaiyaku_owner_renraku" ? <KaiyakuOwnerRenraku column={value} props={this.props} rowIndex={rowIndex} update_kaiyaku_owner_renraku={this.update_kaiyaku_owner_renraku}></KaiyakuOwnerRenraku>
                                              : value.key === "completion_owner_report_at" ? <CompletionOwnerReortAt column={value} props={this.props} rowIndex={rowIndex} update_completion_owner_report_at={this.update_completion_owner_report_at}></CompletionOwnerReortAt>




                                                : <Base column={value} props={this.props} rowIndex={rowIndex}></Base>
              )}
              width={this.state.columns.filter(a => a.key === value.key)[0].width}
              isResizable={true}
              fixed={value.frozen}

            />
          }, this)}



        </Table >

        <Modal isOpen={this.state.rent_money_toggle} toggle={this.rent_money_toggle} size="xl" fade={false}>

          <ModalHeader toggle={this.rent_money_toggle}>入金状況</ModalHeader>
          {/* <ModalBody> */}
          <BulkIndex />
          {/* </ModalBody> */}
          <ModalFooter>
            {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
            {/* <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={() => this.props.change_search_modal(false)}>キャンセル</button> */}
          </ModalFooter>
        </Modal >
      </div>
    );
  }
};


//export  default CustomerList;
const mapStateToProps = (state) => {
  return {

    // room_details: state.roomsReducer.room_details,
    rent_money_bulk_insert_list: state.RentMoneyBulkInsert.rent_money_bulk_insert_list,
  }
}
function mapDispatchToProps(dispatch) {
  return {

    change_rent_money_bulk_insert_list(state) {
      dispatch(RentMoneyBulkInsert.change_rent_money_bulk_insert_list(state))
    },
    change_bk_no(state) {
      dispatch(RentMoney.change_bk_no(state))
    },


  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);